import { type VariantProps, cva } from 'class-variance-authority';
import { type NavItemProps, NavItem } from './NavItem';

const sideNav = cva(
  'fixed flex flex-col min-h-full pb-xxxl left-0 top-0 bg-surface border',
  { variants: { state: { collapsed: 'w-auto', expanded: 'w-[211px]' } } },
);

type SideNavProps = VariantProps<typeof sideNav> & {
  items: NavItemProps[];
  onSignOutClick: () => void;
  collapsed?: boolean;
};

export const SideNav = ({
  items,
  onSignOutClick,
  collapsed = false,
}: SideNavProps) => {
  if (!items.length) {
    return null;
  }

  return (
    <nav
      id="nav"
      role="navigation"
      aria-label="Primary navigation"
      className={sideNav({ state: collapsed ? 'collapsed' : 'expanded' })}
    >
      <div className="flex-1">
        <ul role="menubar" aria-label="Navigation menu items">
          {items.map(({ ...item }) => (
            <NavItem key={item.text} collapsed={collapsed} {...item} />
          ))}
        </ul>
      </div>
      <NavItem
        text="Sign out"
        iconName="logout"
        ariaLabel="Sign out"
        collapsed={collapsed}
        onClick={onSignOutClick}
      />
    </nav>
  );
};
